<template>
    <div
        id="feeds"
        class="container"
    >
        <div class="posts">
            <ResourceScroller
                :v-if="feedPostsScroller !== null"
                :resource="feedPostsScroller.resource"
                :default-params="feedPostsScroller.defaultParams"
                :per-page="10"
            >
                <template slot-scope="{element}">
                    <PostSorter :element="element" :model="element.webstar.data" :showChat="true"/>
                </template>
                <template slot="placeholder" slot-scope="data">
                    <MovieBlockedContainer :placeholder="true"/>
                </template>
            </ResourceScroller>
            <div v-if="loadingResource" class="loading-model">
                <Spinner></Spinner>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from "../Spinner";
import resources from '../../resources';
import ResourceScroller from "../V2/ResourceScroller";
import MovieBlockedContainer from "../Post/Movie/BlockedContainer";
import EventBus from '../../eventbus';
import LayoutDefault from "../../layouts/LayoutDefault";
import PostSorter from "../Post/Sorter.vue";

export default {
    components: {
        PostSorter,
        LayoutDefault,
        Spinner,
        ResourceScroller,
        MovieBlockedContainer,
    },
    data(){
        return {
            loadingResource: true,
        }
    },
    methods: {},
    mounted(){
        EventBus.$on('languageChanged', () => {
//            this.loadModel(model);
        });
    
        EventBus.$on('loadingResource', (value) => {
            this.loadingResource = value;
        });
    },
    computed: {
        feedPostsScroller(){
            return {
                resource: resources.feeds,
                defaultParams: {
                    include: ['webstar'],
                },
            };
        },
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

#feeds{
    background-color: var(--pallete_clear_color);
    padding: 30px 7px;

    .posts{
        margin-bottom: 75px;
        margin-top: 35px;
    }
}
</style>
